import Link from 'next/link'

export function NavigationList({ navigationLinks, navigationLinks2, style }) {
    return (
        <nav className={'NavigationList'}>
            {navigationLinks && Array.isArray(navigationLinks) && navigationLinks.length > 0 && (
                <div className="d-flex align-items-center navigation-container justify-content-between" style={{...style}}>
                    {navigationLinks.map((item) => {
                        // console.log(item);
                        return (
                            <Link href={item.href} key={item.name} className="item-nav">
                                {item.name}
                            </Link>
                        )
                    })}
                </div>
            )}
            {navigationLinks2 && Array.isArray(navigationLinks2) && navigationLinks2.length > 0 && (
                <div className="d-flex align-items-center navigation-container justify-content-between" style={{...style}}>
                    {navigationLinks2.map((item) => {
                        // console.log(item);
                        return (
                            <Link href={item.href} key={item.name} className="item-nav">
                                {item.name}
                            </Link>
                        )
                    })}
                </div>
            )}
        </nav>
    )
}
